//@flow
import * as React from 'react';
import { FormGroup } from 'reactstrap';
import FormInput from './../../components/Inputs/FormInput';
import CpfCnpjInput from './../../components/Inputs/CpfCnpjInput';

type Props = { onChangeText: any, entity: any, onChangeValue: any };

export default class ClienteCrudListFilter extends React.PureComponent<Props> {
  render() {
    const { entity } = this.props;
    return (
      <React.Fragment>
        <FormGroup className="col-12 col-xl-3">
          <FormInput
            label="Nome fantasia"
            placeholder={'Nome fantasia'}
            id={'namefilter'}
            name="nomeFantasia"
            onChange={this.props.onChangeDate}
            type={'text'}
            size={12}
            value={entity.nomeFantasia}
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-3">
          <FormInput
            label="Razão Social"
            placeholder={'Razão Social'}
            id={'razaoSocial'}
            name="razaoSocial"
            onChange={this.props.onChangeDate}
            type={'text'}
            size={12}
            value={entity.razaoSocial}
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-3">
          <CpfCnpjInput
            label="CPF"
            type="text"
            id={'cnpjCpf'}
            name="cnpjCpf"
            size={100}
            placeholder="Digite o CPF ou CNPJ"
            value={entity.cnpjCpf}
            onChange={this.props.onChangeDate}
          />
        </FormGroup>
      </React.Fragment>
    );
  }
}
